var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "17.2791667 0.595012626 17.2791667 5.35511364 22.3541667 5.35511364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3541667,9.99621212 L22.3541667,5.35511364 C22.3541667,5.11710859 22.2333333,4.99810606 22.1125,4.87910354 L18.125,0.952020202 C18.0041667,0.833017677 17.6416667,0.714015152 17.4,0.714015152 L1.69166667,0.714015152 C1.20833333,0.714015152 0.725,1.19002525 0.725,1.66603535 L0.725,27.0135732 C0.725,27.4895833 1.20833333,27.9655934 1.69166667,27.9655934 L21.3875,27.9655934 C21.8708333,27.9655934 22.3541667,27.4895833 22.3541667,27.0135732 L22.3541667,11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAny);
export default __webpack_public_path__ + "static/media/Any.dc74ff12ade4ee5de374561d79d2b68b.svg";
export { ForwardRef as ReactComponent };